<template>
  <div class="container">
    <h4 class="title">{{ $t("new order") }}</h4>
    <div class="columns">
      <div class="column is-three-fifths">
        <drink-selector
          ref="food_selector"
          @dish-selected="add_dish"
        ></drink-selector>
      </div>
      <div class="column">
        <order-emitter ref="order_emitter"></order-emitter>
      </div>
    </div>
  </div>
</template>

<script>
import DrinkSelector from "./drink_selector/Index.vue";
import OrderEmitter from "./order_emitter/Index.vue";

export default {
  name: "FoodIndex",
  components: { DrinkSelector, OrderEmitter },
  data() {
    return {};
  },
  methods: {
    add_dish(dish) {
      this.$refs.order_emitter.set_plate(dish);
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
